import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useSiteContent } from "@/lib/content";

const Footer = () => {
  const content = useSiteContent();
  const tx = (key, fallback) => content?.texts?.[key] || fallback;

  return (
    <footer data-testid="site-footer" className="bg-night border-t border-line">
      <div className="px-6 sm:px-12 lg:px-20 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <p className="text-sm font-semibold tracking-[0.2em] text-bone">NICOLA VERARDO</p>
          <p className="mt-1 text-[10px] font-mono tracking-[0.35em] text-fog">VISUAL PRODUCTION</p>
          <p className="mt-6 text-sm text-fog leading-relaxed max-w-xs">
            {tx("footer_tagline", "Fotografia, motion e AI uniti in un unico linguaggio visivo per prodotti e spazi.")}
          </p>
        </div>
        <nav aria-label="Footer navigazione 1">
          <ul className="space-y-3 text-xs tracking-[0.15em]">
            <li><Link data-testid="footer-link-home" className="text-fog hover:text-bone transition-colors duration-300" to="/">HOME</Link></li>
            <li><Link data-testid="footer-link-product" className="text-fog hover:text-bone transition-colors duration-300" to="/product">PRODUCT</Link></li>
            <li><Link data-testid="footer-link-architecture" className="text-fog hover:text-bone transition-colors duration-300" to="/architecture">ARCHITECTURE</Link></li>
            <li><Link data-testid="footer-link-food" className="text-fog hover:text-bone transition-colors duration-300" to="/food">FOOD</Link></li>
          </ul>
        </nav>
        <nav aria-label="Footer navigazione 2">
          <ul className="space-y-3 text-xs tracking-[0.15em]">
            <li><Link data-testid="footer-link-motion-ai" className="text-fog hover:text-bone transition-colors duration-300" to="/motion-ai">MOTION / AI / VIDEO</Link></li>
            <li><Link data-testid="footer-link-about" className="text-fog hover:text-bone transition-colors duration-300" to="/about">ABOUT</Link></li>
            <li><Link data-testid="footer-link-contact" className="text-fog hover:text-bone transition-colors duration-300" to="/contact">CONTATTI</Link></li>
            <li><Link data-testid="footer-link-privacy" className="text-fog hover:text-bone transition-colors duration-300" to="/privacy">PRIVACY</Link></li>
          </ul>
        </nav>
        <div>
          <p className="text-sm text-bone">verardonicola@gmail.com</p>
          <p className="mt-2 text-sm text-fog">+39 393 3322814</p>
          <div className="mt-6 flex items-center gap-4">
            <a data-testid="footer-social-instagram" href="https://www.instagram.com/nicola.verardo.still_life/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-fog hover:text-gold transition-colors duration-300">
              <Instagram size={18} />
            </a>
          </div>
        </div>
      </div>
      <div className="px-6 sm:px-12 lg:px-20 pb-8 flex flex-col sm:flex-row justify-between gap-2">
        <p className="text-[10px] font-mono tracking-[0.25em] text-fog/60">{tx("footer_rights", "© 2026 NICOLA VERARDO — TUTTI I DIRITTI RISERVATI")}</p>
        <p className="text-[10px] font-mono tracking-[0.25em] text-fog/60">{tx("footer_slogan", "PHOTOGRAPHY. MOTION. AI. ONE VISUAL LANGUAGE.")}</p>
      </div>
    </footer>
  );
};

export default Footer;
